<div class="modal-header">
    <h4 class="modal-title">Bibtex</h4>
    
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <code>{{bibEntry}}</code>
  </div>
  <div class="modal-footer">

  <button class="btn btn-outline-dark" (click)="copy()">{{copy_button_label}}</button>

    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
  </div>